import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DocumentDetailDto } from '../../models/document-details-DTO';
import { PanelList } from '../../../shared/models/panel-list';
import { DocumentLibraryConstants } from '../../document-library-constants';
import { DocumentEffectiveAndPeriodicReviewDateDto } from '../../models/documentEffectiveAndPeriodicReviewDateDTO';
import { DocumentFormattedFile } from '../../models/DocumentFormattedFile';
import { DocumentFormattedFileEdit } from '../../models/DocumentFormattedFileEdit';
import { DocumentService } from '../../services/document.service';
import { ChangeRequestItem } from '../../../../app/change-request/models/change-request-item';
import { PhaseValueConstants } from '../../../shared/constants/phaseValues-constants';
import { catchError, throwError } from 'rxjs';
import { CommonService } from '../../../shared/services/common.service';
import { AuthenticationHelperService } from '../../../shared/components/authentication-maintainance/services/authentication-helper.service';


@Component({
  selector: 'app-approval-status',
  templateUrl: './approval-status.component.html',
  styleUrls: ['./approval-status.component.scss']
})
export class ApprovalStatusComponent implements OnInit {
  @Output() isApprovalStatusModalVisible=new EventEmitter<boolean>();
  @Output() setDocumentDetailsLoader = new EventEmitter<any>();
  display: boolean = true;
  @Input() showApproveButton!:boolean;
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() effectiveDate:any;
  @Input() requestedEffectiveDate:any;
  @Input() periodicReviewDate:any;
  @Input() periodicReviewCycle:any;
  @Input() criItemsToBeUpdate:ChangeRequestItem[]=[];
  @Input() showApproveButtonWhenFileCheckedOut!:boolean;
  documentEffectiveAndPeriodicReviewDateDto!:DocumentEffectiveAndPeriodicReviewDateDto;
  noData: boolean = false;  
  isDocumentVersionDateModalVisible:boolean=false;
  isDocVersionModalVisible:boolean=false;
  selectedDocApprover!:any;
  approvalPendingCount!:number;
  displayCRIHistoryModal:boolean=false;
  CRIItemsExits:boolean=false;
  isTriggeredFromApproval:boolean=false;
  @Input() documentDetailsDto: DocumentDetailDto=new DocumentDetailDto;
  isChangeRequestHistoryModalShow:boolean=true;
  documentPhase!:string;
  isLatestVersion = false;
  latestDocumentVersion = 0;
  confirmationMessage:string=DocumentLibraryConstants.Doc_Version_Approval_Confirmation_Message;
  docVersionReviewData:any;
  showEsignatureConfirmationDialog:any=false;
  displayESignForApproval:any=false;
  documentVersionsHistoryModalInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
  };
  approvalStatusData: PanelList={
    lists:[],
    filters:[],
    sort:[]
  };
  showLoader: boolean = false;
  lists:any=[]
  documentFormattedFile !: DocumentFormattedFile;
  documentFormattedFileEdit !: DocumentFormattedFileEdit;
  
  constructor(private router: Router, private documentService: DocumentService,private messageService: MessageService, 
    private changeDetectorRef: ChangeDetectorRef,private commonService : CommonService, private readonly authenticationHelperService: AuthenticationHelperService) { }

  ngOnInit(): void {
    this.initialize();   
  }

  generateDocumentDetailsDto = (version: string, phase: number) => {
    this.documentDetailsDto.number=this.documentNumber;
    this.documentDetailsDto.version = version;
    this.documentDetailsDto.phase = phase;
  };

  closeChangeRequestItemHistoryModal = (isShow: boolean) => {
    this.isChangeRequestHistoryModalShow = isShow;
    this.displayCRIHistoryModal=false;
    this.displayESignForApproval=true;
  };

  updateIsLatestVersion(isLatest: boolean): void {
    this.isLatestVersion = isLatest;
    this.getdocumentVersions();
  }

  getdocumentVersions = () => {
    this.documentService
      .getDocumentVersions(this.documentDetailsDto.number)
      .subscribe((documentVersions) => {
        this.documentVersionsHistoryModalInput.lists = documentVersions;
        this.latestDocumentVersion =
          documentVersions && documentVersions.length > 0
            ? documentVersions[0]?.version
            : 0;
      });
  };
  
  initialize(){
    this.showLoader = true;
  this.documentService.getApprovalStatus(this.documentNumber,this.documentVersion).subscribe(
    serviceData=>{
      this.approvalStatusData.lists = serviceData;
      this.noData = this.commonService.IsListEmpty(serviceData);
      this.showLoader = false;
      this.addFilters();
      this.addSorting();
      this.approvalPendingCount=this.approvalStatusData.lists.filter((x: { statusName: string; }) => x.statusName == DocumentLibraryConstants.Pending_Phase_Constant).length;
    } );
    
  }

  addFilters():void{
    this.approvalStatusData.enableFilter=true;
    this.approvalStatusData.filters?.push({
      filterDisplayName:"Status",
      filterFieldName:"statusName"
    });
    this.approvalStatusData.filters?.push({
      filterDisplayName:"Approver",
      filterFieldName:"approver"
    } );
  }

  addSorting():void{
  this.approvalStatusData.enableSort=true;
  this.approvalStatusData.sort?.push(
    {
      sortFieldDisplayName:"Status",
      sortFieldName:"statusName"
    }
  );
  this.approvalStatusData.sort?.push(
    {
      sortFieldDisplayName:"Approver",
      sortFieldName:"approver"
    }
  );

  }
  updateCRIItemStatusToDeferAndProceed(event:boolean)
  {
    this.documentService.updatePendingChangeRequestItemStatus(this.documentNumber).subscribe(
      serviceData=>{
        this.openDocumentVersionModal();
    })
  }

  approveDocument(selectedApprover:any){
    this.selectedDocApprover=selectedApprover;
    if(this.approvalPendingCount==1)
    {
      this.displayESignForApproval=true;
      this.documentService.getPendingAndNextPeriodicChangeRequestItemsForDocument
    (this.documentNumber,Number(this.documentVersion),PhaseValueConstants.ReadyForApproval).subscribe(
      serviceData => {
        this.CRIItemsExits=serviceData;
    if(this.CRIItemsExits)
    {
      this.isTriggeredFromApproval=true;
      this.generateDocumentDetailsDto(this.documentVersion,PhaseValueConstants.ReadyForApproval);
      this.isChangeRequestHistoryModalShow = true;
      this.displayCRIHistoryModal=true;
    }
    else
    {
      this.openDocumentVersionModal();
    }

   });
    }  
    else
    {
      this.showEsignatureConfirmationDialog=true;
    }
  }

  openDocumentVersionModal()
  {
    this.isDocumentVersionDateModalVisible=true;
    this.isDocVersionModalVisible=true;
  }
  reloadDocumentDetail() {
    this.isApprovalStatusModalVisible.emit(false);
  }
  handleDocVersionDatesModal(event:any)
  {
    this.isDocumentVersionDateModalVisible=false;
    this.isDocVersionModalVisible=false;
  }

  onConfirm(){
    this.authenticationHelperService.reauth(this.saveSignature.bind(this), this.closeConfirmationModal.bind(this));
  }

  saveSignature(){    
    this.showEsignatureConfirmationDialog=false;
    this.displayESignForApproval=false;
      this.documentEffectiveAndPeriodicReviewDateDto={
        approver: this.selectedDocApprover,
      version :this.documentVersion,
      number:this.documentNumber,
      periodicReviewCycle:this.periodicReviewCycle,
      requestedEffectiveDate:this.requestedEffectiveDate,
      effectiveDate:this.effectiveDate,
      periodicReviewDate:this.periodicReviewDate
  
      }
      // API will return polling headers - parent component will handle polling completion
      this.documentService.approveDocument(this.documentEffectiveAndPeriodicReviewDateDto)
      .pipe(
        catchError((err) => {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: `${err.error}`,
          });
          // On error, close the modal
          this.display=false;
          this.reloadDocumentDetail();
          return throwError(() => err);
        })
      )
        .subscribe(serviceData =>{
            // Success - polling starts automatically, parent will close modal after completion
        });
  }
  closeConfirmationModal(){
    this.showEsignatureConfirmationDialog=false;
    this.displayESignForApproval=false;
    }

}
